<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';


export default {
    data: () => ({
        floorplanImage: true,
    }),
    updated() {
        this.$nextTick(function() {
            this.$eventsBus.$emit('slick-refresh');
        });
    },
    props: [
        "openModal"
    ],
    computed: {
    	...mapGetters({
            getData: 'modal/getData'
        }),

        tall() {
            return this.getData.tall;
        },

        galleryData() {
            return this.getData.images;
        }
    },
    methods: {
        imgSrcSet(image) {
             return `${image.image.small} 383w,
                    ${image.image.medium} 540w,
                    ${image.image.large} 1200w,
                    ${image.image.hd} 1920w
									`;
        }
    }

};
</script>



// WEBPACK FOOTER //
// resources/components/apps/modal-new-home-gallery.vue